<template>
  <div class="about-links card rounded p-3 p-md-4 bg-light border-0 shadow-sm">
    <ul class="list list-unstyled text-left about-links mb-0">
      <li>
        <router-link to="/about">About</router-link>
      </li>
      <li>
        <router-link to="/licensing">License Options</router-link>
      </li>
      <li>
        <router-link to="/faq">FAQ</router-link>
      </li>
      <li>
        <router-link to="/contact">Contact</router-link>
      </li>
      <li>
        <router-link to="/learnmore">Learn More</router-link>
      </li>
      <!-- <li>
        <router-link to="/privacy">Privacy Policy</router-link>
      </li> -->
    </ul>
  </div>
</template>

<script>
export default {
  
}
</script>

<style lang="scss">
.about-links {
  font-size: 1.15rem;
  li {
    margin-bottom: .5rem;
  }
}
</style>